// this file is automatically generated by git.revision.js script
export const versions = { revision: '0adffbf0c9' }; 
 //expose the commit hash to the window object 
//@ts-ignore 
window.rd_version = '0adffbf0c9';
